import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import dayjs from "dayjs";
import util from "@/libs/util.js";
import RefundDepositModal from "./components/RefundDepositModal";
export default {
  components: {
    RefundDepositModal: RefundDepositModal
  },
  data: function data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        operationType: null,
        serialNumber: this.$route.query.serialNumber || "",
        companyName: this.$route.query.company || "",
        transactionSerialNumber: this.$route.query.transactionSerialNumber || ""
      },
      // 搜索表单
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      // 总数

      adminList: [],
      depositForm: {},
      operationDescDialogVisible: false,
      operationDesc: "",
      depositStatusMap: {
        "newly": "10",
        "deduct": "20",
        "refund": "30",
        "audit_refund": "31"
      },
      adminId: util.cookies.get("uuid"),
      refundingTotal: 0,
      // 待退还订单总数

      refundDepositForm: {},
      refundDepositDialogVisible: false,
      depositProofDialogVisible: false,
      depositProofUrls: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getAdminList();
            _this.getCompanyDepositRefundTotal();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    //撤销
    withdraw: function withdraw(row) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var id, serialNumber, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              id = row.id, serialNumber = row.serialNumber;
              _context2.n = 1;
              return _this2.$api.updateDepositRevocation({
                id: id,
                adminId: _this2.adminId
              });
            case 1:
              res = _context2.v;
              if (res.code === 200) {
                // 操作上报
                _this2.$operationLog.push({
                  operationType: 'order',
                  operationOrderType: 'quarter_deposit',
                  code: "revocation",
                  detailBatchNo: serialNumber
                });
                _this2.$message.success("已撤销");
                _this2.getData();
              } else {
                _this2.$message.success(res.message);
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getShowWithdraw: function getShowWithdraw(row) {
      var operationType = row.operationType,
        status = row.status,
        createBy = row.createBy;
      return operationType === "refund" && status === "30" && createBy === this.adminId;
    },
    operationDescDialog: function operationDescDialog(row) {
      this.operationDesc = row.operationDesc;
      this.depositForm = row;
      this.operationDescDialogVisible = true;
    },
    setOperationDesc: function setOperationDesc() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.updateCompanyDepositOrder({
                id: _this3.depositForm.id,
                adminId: util.cookies.get("uuid"),
                operationDesc: _this3.operationDesc
              });
            case 1:
              res = _context3.v;
              if (res.code == 200) {
                // 操作上报
                _this3.$operationLog.push({
                  operationType: 'order',
                  operationOrderType: 'quarter_deposit',
                  code: "note",
                  detailBatchNo: _this3.depositForm.serialNumber
                });
                _this3.$message.success("操作成功");
                _this3.operationDescDialogVisible = false;
                _this3.getData();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    editDeposit: function editDeposit(row) {
      this.refundDepositForm = JSON.parse(JSON.stringify(row));
      this.$refs.refundDepositModal.edit(this.refundDepositForm);
    },
    getAdminList: function getAdminList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.getAdminUser({
                type: "all"
              });
            case 1:
              res = _context4.v;
              _this4.adminList = res.data;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    refundDepositDialog: function refundDepositDialog(row) {
      this.refundDepositForm = JSON.parse(JSON.stringify(row));
      this.refundDepositForm.certificateUrl = '';
      // row.oldData = true
      if (row.oldData != 1) {
        this.refundDepositDialogVisible = true;
      } else {
        this.$refs.refundDepositModal.show(this.refundDepositForm);
      }
    },
    refundDeposit: function refundDeposit() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (_this5.refundDepositForm.certificateUrl) {
                _context5.n = 1;
                break;
              }
              _this5.$message.error("请上传押金退还凭证");
              return _context5.a(2);
            case 1:
              _context5.n = 2;
              return _this5.$api.updateDepositRefunded({
                id: _this5.refundDepositForm.id,
                operationType: "refund",
                certificateUrl: _this5.refundDepositForm.certificateUrl,
                adminId: util.cookies.get("uuid")
              });
            case 2:
              res = _context5.v;
              if (res.code == 200) {
                // 操作上报
                _this5.$operationLog.push({
                  operationType: 'order',
                  operationOrderType: 'quarter_deposit',
                  code: "refund",
                  detailBatchNo: _this5.refundDepositForm.serialNumber
                });
                _this5.$message.success("操作成功");
                _this5.refundDepositDialogVisible = false;
                _this5.getData();
                _this5.getCompanyDepositRefundTotal();
              }
            case 3:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pageNum = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var params, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (type === "search") {
                _this6.searchForm.pageNum = 1;
              }
              params = JSON.parse(JSON.stringify(_this6.searchForm));
              if (params.operationType === "refund") {
                params.status = 31;
              }
              if (params.operationType === "refunding") {
                params.operationType = 'refund';
                params.status = 30;
              }
              _this6.tableLoading = true;
              _context6.n = 1;
              return _this6.$api.getCompanyDepositList(params);
            case 1:
              res = _context6.v;
              res.data.content.forEach(function (item) {
                item.createDate = dayjs(item.createDate).format("YYYY-MM-DD HH:mm:ss");
              });
              _this6.tableData = res.data.content;
              _this6.total = res.data.totalCount;
              _this6.tableLoading = false;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getCompanyDepositRefundTotal: function getCompanyDepositRefundTotal() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _yield$_this7$$api$ge, data;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this7.$api.getCompanyDepositRefundTotal();
            case 1:
              _yield$_this7$$api$ge = _context7.v;
              data = _yield$_this7$$api$ge.data;
              _this7.refundingTotal = data;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    businessLicenseDetail: function businessLicenseDetail(row) {
      // this.$hevueImgPreview({
      //     multiple: true, // 开启多图预览模式
      //     nowImgIndex: 0, // 多图预览，默认展示第二张图片
      //     // keyboard: true, // 开启键盘控制
      //     imgList: row.refundProof ?  [row.certificateUrl, row.refundProof] : [row.certificateUrl], // 需要预览的多图数组
      // });
      if (row.refundProof) {
        this.depositProofUrls = [row.certificateUrl, row.refundProof];
      } else {
        this.depositProofUrls = [row.certificateUrl];
      }
      this.depositProofDialogVisible = true;
      this.depositForm = row;
    },
    //预览 pdf 文件
    previewPdf: function previewPdf(url) {
      window.open(url);
    }
  }
};